import styled from '@emotion/styled';

import { screen } from '@/components/common/breakpoints';
import { PrimaryButton } from '@/components/common/Buttons';
import { Heading, HeadingLevel } from '@/components/common/MarkUp';
import { Section } from '@/components/layout/Section';
import { colourTokens } from '@/styles/colours';

import type { SanityProgrammeSpecificationsType } from '@/types/sanity';

export type ProgrammeSpecificationsProps = Omit<
  SanityProgrammeSpecificationsType,
  'specifications'
> & {
  specifications?: Array<
    SanityProgrammeSpecificationsType['specifications'][0] & {
      url?: string;
    }
  >;
};
const ProgrammeSpecifications = ({
  specifications,
}: ProgrammeSpecificationsProps) => {
  return (
    <Section backgroundColour="--background-subtle">
      <ListContainer>
        {specifications.map((specification) => (
          <SpecificationWrapper key={specification._key}>
            <HeadingLevel>
              <Heading size="subheadline-bold">{specification.name}</Heading>
              <PrimaryButton
                href={`${specification.url}?dl=`}
                componentTheme="light"
              >
                Download
              </PrimaryButton>
            </HeadingLevel>
          </SpecificationWrapper>
        ))}
      </ListContainer>
    </Section>
  );
};
const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  margin: 0 var(--spacing-500);
  padding: var(--spacing-300) 0;

  ${screen.md} {
    padding: var(--spacing-small) 0;
  }
`;

const SpecificationWrapper = styled.div`
  background: var(${colourTokens.surface.warmBase.token});
  display: flex;
  justify-content: space-between;
  padding: var(--spacing-500);
  margin-bottom: var(--spacing-large);
  border-radius: var(--radius-m);
  width: 100%;
  flex-direction: column;
  align-items: center;

  ${Heading} {
    margin-bottom: var(--spacing-300);
    text-align: center;
    color: var(${colourTokens.text.action.token});
  }

  ${screen.md} {
    flex-direction: row;
    align-items: center;
    max-width: 1000px;
    ${Heading} {
      margin: 0;
      text-align: left;
    }

    &:first-of-type {
      margin-top: var(--spacing-800);
    }

    a {
      flex-shrink: 0;
      svg {
        transform: rotate(90deg);
      }
    }
  }
`;

export { ProgrammeSpecifications };
